<template>
  <div class="home">
    <SignUpThanksPage :npi_status="npi_status"/>
  </div>
</template>

<script>
import SignUpThanksPage from '../components/elements/pages/SignUpThanksPage.vue'
export default {
  name: 'SignUpThanks',
  metaInfo: {
    title: 'Sign Up Thanks'
  },
  props: {
    npi_status: false
  },
  components: {
    SignUpThanksPage
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
section.home-hero {
  background-size: 100% 100%;
  padding: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
  }
}
</style>
